import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';
import { IFormCheckboxComponent } from '../interfaces/form-checkbox.interface';

@Component({
  selector: 'app-form-checkbox-with-description',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatCheckboxModule, LabelsProviderPipe],
  templateUrl: './form-checkbox-with-description.component.html',
  styleUrl: './form-checkbox-with-description.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormCheckboxWithDescriptionComponent implements IFormCheckboxComponent {
  public fg = input.required<UntypedFormGroup>();
  public checked = model.required<boolean>();
  public titleLabelKey = input.required<string>();
  public descriptionLabelKey = input.required<string>();

  public onCheckboxChange(checked: boolean): void {
    this.checked.set(checked);
  }
}
